import { z } from 'zod'

export const FoodStockFoodItemCondition = z.enum(['IN_USE', 'SEALED'])
export type FoodStockFoodItemCondition = z.infer<
  typeof FoodStockFoodItemCondition
>
